import { FunctionComponent, ReactNode } from 'react'

import styled, { css } from 'styled-components'

interface LabelProps {
  labelColor: string | undefined
  children: ReactNode
}

type StyledLabelProps = Pick<LabelProps, 'labelColor'>

const StyledLabel = styled.div<StyledLabelProps>`
  ${({
    theme: {
      spacing: { spacing4 },
      colors: { staticWhite, fillBrand },
      typography: {
        catchword: {
          small2: { bundledCSS: small2CatchwordCSS },
        },
      },
      utils: { ellipsis },
    },
    labelColor,
  }) => css`
    box-sizing: border-box;
    ${ellipsis('100%', 1)};
    display: inline-block;
    ${small2CatchwordCSS};
    color: ${staticWhite};
    background-color: ${labelColor ?? fillBrand};
    padding: 0.28em 0.4em 0.2em;
    margin-bottom: ${spacing4};
    text-transform: uppercase;

    &:empty {
      background-color: transparent;
      padding-left: 0;
      padding-right: 0;

      &:before {
        content: '​';
        width: 0;
      }
    }
  `}
`

const Label: FunctionComponent<LabelProps> = ({ labelColor, children }) => {
  return <StyledLabel labelColor={labelColor}>{children}</StyledLabel>
}

export default Label
